<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 10:55:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-05-20 16:30:21
 * @FilePath: 
 * @Description: 选择人数页面
-->
<template>
  <div class="check_person_con">
    <div class="person_title_con">
      <img src="@/assets/images/point-user.png" alt="" />
      <p class="c-ft-26">亲爱的顾客，欢迎您用餐～</p>
    </div>
    <div class="select_number_con">
      <div class="c-ft-32">请问您几人用餐？</div>
      <div class="select_tips c-ft-26">
        <p>请选择人数</p>
      </div>
      <ul class="table_number_con">
        <li
          v-for="(item, index) in 11"
          :class="[{ active_item: tableNumber == item }, 'table_number_item']"
          :key="index"
          @click="onClickTableNumber(item)"
        >
          {{ item }}
        </li>
        <li
          :class="[{ active_item: tableNumber == 'more' }, 'table_number_item']"
          @click="onClickTableNumber('more')"
        >
          更多
        </li>
      </ul>
      <van-field
        v-if="tableNumber == 'more'"
        v-model="inputTableNumber"
        type="digit"
        label=""
        placeholder="请输入人数"
      />

      <div class="number_submit_btns">
        <van-button
          v-if="fromPage == 'NewPlaceOrder' && !isFromMicropoint"
          color="#333"
          block
          round
          @click="handleToOrderPage"
          >确定</van-button
        >
        <van-button
          v-else
          color="#333"
          block
          round
          @click="handleToOrderPage"
          >{{ isFromMicropoint ? "继续下单" : "开始点餐" }}</van-button
        >
      </div>
    </div>
    <!-- <van-cell-group>
      <van-field
        v-model="numValue"
        label="就餐人数"
        placeholder="请输入就餐人数"
        readonly
        :error-message="errorMsg"
      >
        <template #extra>
          <span>人</span>
        </template>
      </van-field>
    </van-cell-group>
    <van-number-keyboard v-model="numValue" :show="true" :maxlength="6" /> -->
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
export default {
  name: "InputPeopleNum",
  props: {},
  data() {
    return {
      // numValue: "",
      errorMsg: "",
      tableNumber: 1,
      inputTableNumber: "",
    };
  },
  components: {},
  created() {
    const queryData = this.$route.query;

    this.fromPage = queryData.fromPage;
    this.saasCode = queryData.saasCode;
    this.diningRoomId = queryData.diningRoomId;
    this.isFromMicropoint = queryData.isFromMicropoint;
  },
  mounted() {},
  methods: {
    onClickTableNumber(num) {
      this.tableNumber = num;
    },
    handleToOrderPage() {
      if (this.tableNumber == "more" && !this.inputTableNumber) {
        this.$toast("请输入就餐人数");
        return;
      }
      // if (this.numValue == 0) {
      //   return (this.errorMsg = "就餐人数至少1人");
      // }
      this.handleChangePeopleNum();
      this.$router.replace({
        name: this.fromPage,
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    handleChangePeopleNum() {
      this.$store.dispatch(
        "order/SET_ORDER_PEOPLE",
        this.tableNumber == "more"
          ? this.inputTableNumber - 0
          : this.tableNumber
      );
    },
  },
};
</script>
<style scoped lang="scss">
.check_person_con {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
  padding-top: 26px;
  box-sizing: border-box;
  .person_title_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 53px;
    img {
      width: 158px;
      height: 158px;
      margin-bottom: 16px;
    }
  }
  .select_number_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 32px 32px 0px 0px;
    flex: 1;
    padding: 48px 50px;
    .select_tips {
      margin: 64px 0 32px;
      position: relative;
      display: flex;
      align-items: center;

      p {
        // width: 150px;
        &::before {
          content: " ";
          position: absolute;
          width: 4px;
          height: 4px;
          top: 13px;
          left: -30px;
          border-radius: 50%;
          background-color: #333;
        }
        &::after {
          content: "";
          position: absolute;
          width: 4px;
          height: 4px;
          top: 13px;
          right: -30px;
          border-radius: 50%;
          background-color: #333;
        }
      }
      // span {
      //   width: 3px;
      //   height: 3px;
      //   border-radius: 50%;
      //   background-color: #333;
      // }
      &::before {
        content: " ";
        position: absolute;
        width: 51px;
        height: 1px;
        top: 13px;
        left: -90px;
        border-radius: 50%;
        background-color: #333;
      }
      &::after {
        content: "";
        position: absolute;
        width: 51px;
        height: 1px;
        top: 13px;
        right: -90px;
        border-radius: 50%;
        background-color: #333;
      }
    }
  }
}
.table_number_con {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .table_number_item {
    padding: 20px 0;
    box-sizing: border-box;
    width: 22.5%;
    text-align: center;
    border: 1px solid #999999;
    border-radius: 40px;
    color: #333;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 36px;

    &.active_item {
      background: #989898;
      border: 1px solid #989898;
      color: #fff;
    }

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
.number_submit_btns {
  padding: 30px;
  width: 100%;
  margin-top: 120px;
}
</style>
